<template>
  <div class="popup-wrap">
    <header v-if="device === 'mobile'">
      <h1 class="a11y-hidden">웨이브</h1>
      <div class="header-top">
        <h2 class="hd-title">Wavve 이용권 소개</h2>
        <button @click="close" class="btn-close" type="button">
          <span class="a11y-hidden">나가기</span>
          <span class="icon-close">
            <CloseButtonIcon />
          </span>
        </button>
      </div>
    </header>
    <div v-if="!isLoading" class="popup-content" >
      <div class="ticket-intro-popup">
        <table>
          <caption class="a11y-hidden">Wavve 이용권 소개</caption>
          <colgroup>
            <col width="33.3333%">
            <col width="33.3333%">
            <col width="33.3333%">
          </colgroup>
          <thead>
          <tr>
            <th>Basic</th>
            <th>Standard</th>
            <th>Premium</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>{{basicAmount}}원</td>
            <td>{{standardAmount}}원</td>
            <td>{{premiumAmount}}원</td>
          </tr>
          <tr>
            <td colspan="3">
              <span>방송&plus;LIVE&plus;해외 시리즈 시청 (타임머신, QVOD 포함)</span>
              <span>&plus;</span>
              <span>Wavvie 영화 시청</span>
            </td>
          </tr>
          <tr>
            <td>HD</td>
            <td>FHD</td>
            <td>FHD 이상</td>
          </tr>
          <tr>
            <td>1대</td>
            <td>2대</td>
            <td>4대</td>
          </tr>
          <tr>
            <td>모바일&plus;PC</td>
            <td colspan="2">전체 디바이스</td>
          </tr>
          <tr v-if="device !== 'ios'">
            <td colspan="3">개별 구매 영화는 별도 구매 필요</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import CloseButtonIcon from '@/assets/svg/common/ic_gnb_close_w.svg'
import utils from '@/common/util/utils'
import { VoucherService } from '@/common/api/api.service'
import { get } from 'lodash'
import { DEVICE_TYPE_IOS } from '@/common/devicetype.const'
import {PAYMENT_GATE_TYPE_GOOGLE_IN_APP_PURCHASE, PAYMENT_GATE_TYPE_ONE_STORE} from '@/common/constant'
export default {
  name: 'VoucherPopupInfo',
  components: {
    CloseButtonIcon
  },
  data () {
    return {
      basicAmount: '7,900',
      standardAmount: '10,900',
      premiumAmount: '13,900',
      device: utils.cookies.getDevice(),
      isLoading: true
    }
  },
  methods: {
    close () {
      this.$router.back()
    },
    setNumberCommas (data) {
      if (!data) return 0
      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    setData () {
      this.isLoading = true
      let voucherAPI = VoucherService.getAllPurchase
      if (utils.cookies.getDevice() === DEVICE_TYPE_IOS) {
        voucherAPI = VoucherService.getAllPurchaseForIOS
      }
      if (utils.getPgName() === PAYMENT_GATE_TYPE_ONE_STORE || utils.getPgName() === PAYMENT_GATE_TYPE_GOOGLE_IN_APP_PURCHASE) {
        voucherAPI = () => VoucherService.getAllPurchaseByPgName(utils.getPgName())
      }

      voucherAPI().then(({ data }) => {
        let wavveData = get(data.filter((voucherItem) => voucherItem.passgroup_type === 'wavve'), '0.productgroups.0.products', {})
        wavveData.forEach((item) => {
          const concurrency = get(item, 'concurrency.0', '')
          const productName = get(concurrency, 'product_name', '')
          if (productName === 'Basic') {
            this.basicAmount = this.setNumberCommas(concurrency.amount)
          } else if (productName === 'Standard') {
            this.standardAmount = this.setNumberCommas(concurrency.amount)
          } else {
            this.premiumAmount = this.setNumberCommas(concurrency.amount)
          }
        })
        this.isLoading = false
      })
    }
  },
  created () {
    this.setData()
  }
}
</script>
<style scoped>
  .ticket-intro-popup{
    margin: 20px auto;
    padding: 0 10px;
  }

  .ticket-intro-popup table{
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    border: 1px solid #2f2f2f
  }
  .ticket-intro-popup th, td{
    padding: 15px 0;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    border: 1px solid #2f2f2f
  }
  .ticket-intro-popup th{
    font-weight: 400;
    color: #fff
  }
  .ticket-intro-popup td{
    color: #a5a5a5
  }
  .ticket-intro-popup td span{
    display: block;
  }
</style>
